"use client"

import { clx } from "@medusajs/ui"

type FilterCheckboxGroupProps = {
  title: string
  items: {
    value: string
    label: string
  }[]
  selectedValues: string[]
  handleChange: (value: string) => void
  "data-testid"?: string
}

const FilterCheckboxGroup = ({
  title,
  items,
  selectedValues,
  handleChange,
  "data-testid": dataTestId,
}: FilterCheckboxGroupProps) => {
  return (
    <div className="flex gap-x-3 flex-col gap-y-3">
      <span className="text-sm font-medium text-brown-dark">{title}</span>
      <div className="flex flex-col gap-y-2" data-testid={dataTestId}>
        {items?.map((item) => {
          const isSelected = selectedValues.includes(item.value)
          return (
            <label
              key={item.value}
              className="flex items-center gap-x-2 cursor-pointer group"
            >
              <div
                className={clx(
                  "w-4 h-4 rounded border-2 flex items-center justify-center transition-colors",
                  {
                    "bg-brown-dark border-brown-dark": isSelected,
                    "border-beige group-hover:border-brown-light": !isSelected,
                  }
                )}
              >
                {isSelected && (
                  <svg
                    className="w-3 h-3 text-cream"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={3}
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                )}
              </div>
              <input
                type="checkbox"
                className="hidden"
                checked={isSelected}
                onChange={() => handleChange(item.value)}
              />
              <span
                className={clx(
                  "text-sm transition-colors",
                  {
                    "text-brown-dark font-medium": isSelected,
                    "text-brown-light group-hover:text-brown-dark": !isSelected,
                  }
                )}
              >
                {item.label}
              </span>
            </label>
          )
        })}
      </div>
    </div>
  )
}

export default FilterCheckboxGroup

